import { styled } from '@mui/material';
import { UrlMetadata } from 'src/modules/url-metadata/private/components/UrlMetadata';
import { EmbedRendererProps } from './types';

const Iframe = styled('iframe')(() => ({
  width: '100%',
  margin: '0 auto',
  border: 'none',
}));

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));

const UrlMetadataStyled = styled(UrlMetadata)(({ theme }) => ({
  display: 'block',
  position: 'relative',
  cursor: 'pointer',
  padding: theme.spacing(2, 1.5),
}));

type PortalProps = Omit<React.HTMLProps<HTMLIFrameElement>, 'as'> & {
  aspectRatio?: string;
  title: string;
  fullHeight?: boolean;
  withMetadata?: boolean;
} & EmbedRendererProps<any>;

export const Portal = ({
  aspectRatio,
  url,
  title,
  fullHeight,
  metadata,
  withMetadata,
  onMetadataChange,
  selected: _,
  ...rest
}: PortalProps) => (
  <Container>
    <Iframe
      {...rest}
      src={url}
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-presentation"
      title={title}
      loading="lazy"
      allowFullScreen
      style={{
        aspectRatio,
        height: fullHeight ? '100%' : undefined,
      }}
    />
    {withMetadata && (
      <UrlMetadataStyled
        url={url}
        metadata={metadata}
        onMetadataChange={onMetadataChange}
        preferFavicon
      />
    )}
  </Container>
);
